const NON_EDITOR_STOREFRONT_PAGES = ['/marketplace', '/direct-links', '/mount-points', '/plugins', '/club', '/credits'];

/**
 * True on a funnel editor page: full-bleed, no sidebar, no banners. The storefront lists and the
 * other storefront pages keep the normal layout. `path` has no trailing slash.
 */
export function isFunnelEditorPath(path: string): boolean {
  if (!path.includes('/storefront')) return false;
  if (path.endsWith('/storefront') || path.endsWith('/storefront/funnels')) return false;
  return !NON_EDITOR_STOREFRONT_PAGES.some((page) => path.includes(page));
}
